import { render, staticRenderFns } from "./simplifyContract.vue?vue&type=template&id=4c770907&scoped=true"
import script from "./simplifyContract.vue?vue&type=script&lang=js"
export * from "./simplifyContract.vue?vue&type=script&lang=js"
import style0 from "./simplifyContract.vue?vue&type=style&index=0&id=4c770907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c770907",
  null
  
)

export default component.exports